module.exports = __webpack_public_path__ + "img/sort-asc.c1537c50.svg";